/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import {
	Button,
	Icon,
	Spinner,
	Card,
	CardHeader,
	CardBody,
} from '@wordpress/components';
import {
	withSelect,
} from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';
import apiFetch from '@wordpress/api-fetch';
import { useState, useEffect } from '@wordpress/element';
import { compose } from '@wordpress/compose';

/**
 * External dependencies.
 */
import classnames from 'classnames';
import Masonry from 'react-masonry-component';

// import '../extensions/store/template-kit';
import KitDetails from './kit-detail';
const { is_pro_activated: isProActivated } = window._gutenify_vars;

const CustomizerPanel = ( props ) => {
	const { getKits } = props;

	const [
		{
			showLoadingSpinner,
			showKitDetail,
			currentKit,
			templateKits,
		},
		setState,
	] = useState( {
		showLoadingSpinner: true,
		showKitDetail: false,
		currentKit: {},
		templateKits: [],
		// isTemplateReset: false,
	} );

	const updateState = ( data ) => {
		setState( ( prevState ) => {
			return {
				...prevState,
				...data,
			};
		} );
	};
	useEffect( () => {
		const kits = getKits();
		kits.then( ( res ) => {
			updateState( {
				showLoadingSpinner: false,
				templateKits: res,
			} );
		} );
	}, [] );

	const closeKitDetailModal = () => {
		updateState( {
			showKitDetail: false,
		} );
	};

	return (
		<>
			<Card className="gutenify--template-kit-browser--header-section">
				<CardHeader>
					<h3
					// id="components-modal-header-1"
					// className="components-modal__header-heading"
					>
						{ ! showKitDetail && __( 'Gutenify Template Kits', '@@text_domain' ) }
						{ showKitDetail && templateKits && currentKit.title }
					</h3>
					<div className="gutenify--template-kit-browser--header-left">

						{ showLoadingSpinner && (
							<div className="gutenify-plugin-templates-modal-loading-spinner">
								<Spinner />
							</div>
						) }
						<span>
							<strong>{ __( 'Total kits:' ) }</strong> { templateKits.length }
						</span>
						<Button
							isSecondary
							onClick={ () => {
								updateState( {
									showLoadingSpinner: true,
								} );
								const kits = getKits( true );
								kits.then( ( res ) => {
									updateState( {
										showLoadingSpinner: false,
										templateKits: res,
									} );
								} );
							} }
						>
							<Icon icon="update" className="example-class" />
							Refresh
						</Button>
					</div>
				</CardHeader>
			</Card>
			{ ! isProActivated && <Card className="gutenify-template-kit-browser-pro-notice">
				<CardBody>
					Get all our premium features. Checkout <a href="https://gutenify.com/pricing" target="__blank"><i className="fa fa-fire"></i> Gutenify PRO</a>.
				</CardBody>
			</Card> }
			<div
				className={ classnames(
					'gutenify-template-kit-browser-wrapper',
					showLoadingSpinner && 'gutenify-template-kit-browser-loading',
					showKitDetail && 'gutenify-template-kit-browser-has-kit-details'
				) }
			>
				<div className="gutenify-template-kit-browser-listing-area">
					<Card>
						<CardBody>
							{ ! showKitDetail && templateKits && (
								<Masonry
									className="gutenify-template-kit-browser-lists"
									elementType="ul"
									disableImagesLoaded={ false }
									updateOnEachImageLoad
									options={ {
										transitionDuration: 0,
									} }
								>
									{ templateKits.map( ( kit ) => {
										let withThumb = !! kit.thumbnail;

										if ( ! withThumb ) {
											kit.thumbnail = `${ window._gutenify_kit.plugin_directory_url }/assets/images/kit-placeholder.png`;
											kit.thumbnail_height = 800;
											kit.thumbnail_width = 800;
											withThumb = true;
										}

										let thumbAspectRatio = false;

										if ( kit.thumbnail_height && kit.thumbnail_width ) {
											thumbAspectRatio =
												kit.thumbnail_height / kit.thumbnail_width;
										}
										return (
											<li
												className={ classnames(
													'gutenify-plugin-templates-list-item',
													withThumb
														? ''
														: 'gutenify-plugin-templates-list-item-no-thumb'
												) }
												key={ kit.kit_name }
											>
												<button
													onClick={ () => {
														updateState( {
															currentKit: kit,
															showKitDetail: true,
														} );
													} }
												>
													{ withThumb ? (
														<div className="gutenify-plugin-templates-list-item-image">
															{ !! kit.is_pro ? <span className="gutneify-kit-type-label gutneify-kit-type-label-pro">PRO</span> : <span className="gutneify-kit-type-label gutneify-kit-type-label-free">FREE</span> }
															{ thumbAspectRatio ? (
																<div
																	className="gutenify-plugin-templates-list-item-image-sizer"
																	style={ {
																		paddingTop: `${ 100 * thumbAspectRatio }%`,
																	} }
																/>
															) : (
																''
															) }
															{ /* <LazyLoad overflow offset={ 100 }> */ }
															<img
																src={ kit.thumbnail }
																alt={ kit.title }
																width="100"
															/>
															{ /* </LazyLoad> */ }
														</div>
													) : (
														''
													) }
													<span>{ kit.title }</span>
												</button>
											</li>
										);
									} ) }
								</Masonry>
							) }

						</CardBody>
					</Card>
				</div>
			</div>
			{ showKitDetail && <KitDetails onClose={ closeKitDetailModal } kit={ currentKit } /> }
		</>
	);
};
export default compose( [
	withSelect( ( ) => {
		const getKits = ( reset = false ) => {
			return new Promise( function( resolve, reject ) {
				apiFetch( {
					path: '/gutenify/v1/get_template_kit/?reset=' + reset,
				} )
					.then( ( res ) => {
						resolve( res.response );
					} )
					.catch( ( error ) => {
						reject( error );
					} );
			} );
		};
		return {
			getKits,
		};
	} ),
] )( CustomizerPanel );
